export const hasOwnProp = <T extends string>(
  props: unknown,
  property: T,
): props is Record<T, unknown> => {
  return (
    typeof props === "object" && Object.hasOwnProperty.call(props, property)
  );
};
